import React, { Fragment } from 'react';
import { Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import { numericality } from 'redux-form-validators';

const styles = {
    textField: {
        floatingLabelStyle: {
            fontSize: '12px',
        },
    },
};

const PortRestrictions = () => 
    (
        <Fragment>
            <div className='main__title'>
                PORT Restrictions
            </div>

            <div className='port-restrictions'>
                <div className='list'>
                    <div className='item'>
                        <Field
                            component={TextField}
                            name='portLimitations.maxDraught'
                            floatingLabelText='Max Draft, m:'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            validate={[numericality({ '>=': 0, '<=': 100, allowBlank: true })]}
                            fullWidth
                        />
                    </div>
                    <div className='item'>
                        <Field
                            component={TextField}
                            name='portLimitations.maxBeam'
                            floatingLabelText='Max Beam, m:'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            validate={[numericality({ '>=': 0, '<=': 100, allowBlank: true })]}
                            fullWidth
                        />
                    </div>
                    <div className='item'>
                        <Field
                            component={TextField}
                            name='portLimitations.maxLOA'
                            floatingLabelText='Max LOA, m:'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            validate={[numericality({ '>=': 0, '<=': 1000, allowBlank: true })]}
                            fullWidth
                        />
                    </div>
                    <div className='item'>
                        <Field
                            component={TextField}
                            name='portLimitations.maxDWT'
                            floatingLabelText='Max DWT, mt:'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            validate={[numericality({ '>=': 0, '<=': 1000000, allowBlank: true })]}
                            fullWidth
                        />
                    </div>
                    <div className='item'>
                        <Field
                            component={TextField}
                            name='portLimitations.channelDepth'
                            floatingLabelText='Channel Depth, m:'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            validate={[numericality({ '>=': 0, '<=': 100, allowBlank: true })]}
                            fullWidth
                        />
                    </div>
                    <div className='item'>
                        <Field
                            component={TextField}
                            name='portLimitations.anchorageDepth'
                            floatingLabelText='Anchorage Depth, m:'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            validate={[numericality({ '>=': 0, '<=': 100, allowBlank: true })]}
                            fullWidth
                        />
                    </div>
                    <div className='item'>
                        <Field
                            component={TextField}
                            name='portLimitations.meanTide'
                            floatingLabelText='Mean Tide, m:'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            validate={[numericality({ '>=': 0, '<=': 100, allowBlank: true })]}
                            fullWidth
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );

export default PortRestrictions;



// WEBPACK FOOTER //
// ./app/components/Regions/Port/PortRestrictions.jsx